import i18next from "i18next";
import { useState } from "react";
import { useAuth } from "react-oidc-context";

const AuthContent = () => {
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  
  if (!auth.isAuthenticated) {
    return (
      <div className="flex h-screen justify-center items-center">
        <div className="flex flex-col gap-3 bg-white shadow-lg p-8 rounded text-center">
          <p className="text font-OpenSans font-semibold">
            {i18next.t("not_authenticated")}
          </p>
          <button
            onClick={() => {
              auth.signinRedirect();
              setIsLoading(true);
            }}
            disabled={isLoading}
            className="bg-quaternary text-white py-1 px-4 rounded w-1/2 mx-auto flex items-center justify-center gap-2 disabled:opacity-70 min-h-[32px]"
          >
            {isLoading ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              "Login"
            )}
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default AuthContent;
